module.exports = __webpack_public_path__ + "static/media/fog2026.7e59a232.png";